import _ from 'lodash'
import qc from 'qc'
import { clone } from '@ps/bridge/qc/node'
import gameIframe from '@ps/bridge/iframe/iframe'
import { getDescendants, getDescendantsText } from '@ps/bridge/qc/node/utils'
import { isSquaredUp } from '@ps/bridge/qc/base'
import { updateTextNodeLangKeyAfterCloneNode } from '@ps/workbench/layer/text'

export function copyScene({
  sceneNode,
  index,
}: {
  sceneNode: qc.Node
  index: number
}): qc.Node {
  index = _.isNumber(index) && index >= 0 ? index : 0
  const cloneNode = clone({
    node: sceneNode,
    parent: gameIframe.gamePlay,
    index,
  })
  const prefix = 'IVScene_'
  cloneNode.name = prefix + cloneNode.uuid.slice(0, 8)
  cloneNode.uniqueName = sceneNode.uniqueName + '_copy'

  // 处理九宫格图片属性复制
  const squareUpNodes = getDescendants(sceneNode, null, false).filter(
    isSquaredUp,
  )
  const newSquareUpNodes = getDescendants(cloneNode, null, false).filter(
    isSquaredUp,
  )
  if (newSquareUpNodes.length) {
    newSquareUpNodes.forEach((item) => {
      const node = squareUpNodes.find(
        (el) => el.texture.atlas.url === item.texture.atlas.url,
      )
      if (node) {
        item.borderLeft = node.borderLeft
        item.borderBottom = node.borderBottom
        item.borderTop = node.borderTop
        item.borderRight = node.borderRight
      }
    })
  }

  const textNodes = getDescendantsText(cloneNode)
  textNodes.forEach((item) => {
    // 复制文本节点后，更新文本节点多语言脚本的 langKey 属性
    updateTextNodeLangKeyAfterCloneNode(item)
  })

  return cloneNode
}
